import isMobilePhone from 'validator/es/lib/isMobilePhone'
import z from 'zod'

export const states = ['QLD', 'NSW', 'VIC', 'TAS', 'SA', 'WA', 'NT', 'ACT'] as const
export type State = (typeof states)[number]

export const mobileType = z.string().refine(val => isMobilePhone(val.replaceAll(' ', ''), 'en-AU'), {
    message: 'Invalid mobile number',
})
export const landlineType = z
    .string()
    .regex(/^\(?(0[2378])\)?[\s-]?(\d{4})[\s-]?(\d{4})$|^\(?(1300|1800)\)?[\s-]?(\d{3})[\s-]?(\d{3})$/, {
        message: 'Invalid landline number',
    })

export const mobileOrPhoneType = z.union([mobileType, landlineType], {
    errorMap: error => ({ message: 'Invalid mobile or phone number' }),
})

export const AddressSchema = z.object({
    unitNumber: z.string().optional(),
    streetNumber: z.string().min(1),
    streetName: z.string().min(1),
    suburb: z.string().min(1),
    postcode: z.string().length(4),
    state: z.enum(states),
    manual: z.boolean().default(false),
})

export const formatAddress = (address: AddressSchema, type: 'full' | 'short' | 'line2' = 'short') => {
    const short = `${address.unitNumber && address.unitNumber.length > 0 ? address.unitNumber + '/' : ''}${address.streetNumber} ${address.streetName}`
    const line2 = `${address.suburb} ${address.state} ${address.postcode}`
    if (type === 'short') {
        return short
    } else if (type === 'line2') {
        return line2
    } else {
        return `${short} ${line2}`
    }
}

export type AddressSchema = z.infer<typeof AddressSchema>
